import { GridInputs } from "../../../../../components/Functional";
import { Spinner } from "../../../../../components/ui";
import { useEntitiesLazy } from "../../../../../hooks/useEntities";

const Registrar = props => {
  const { formik } = props || {};
  const [fetchEntities, { loading, entities }] = useEntitiesLazy();

  const inputs = {
    className: "mt-5 grid grid-cols-1 gap-4 lg:grid-cols-4 lg:gap-16",
    inputs: [
      {
        label: "Registrar",
        name: "registrarId",
        onFocus: () => {
          if (!entities) {
            fetchEntities();
          }
        },
        options:
          entities?.edges?.map(item => ({
            label: item?.name,
            value: item?.id,
          })) || [],
        type: "multi-select",
      },
    ],
  };

  const gridInputProps = {
    formik,
    ...inputs,
  };

  return (
    <div className="w-full">
      {loading && <Spinner />}
      <GridInputs {...gridInputProps} />
    </div>
  );
};

export default Registrar;
